<template>
	<div class="newslistbox">
		
		<div class="topbar f-row-start-b">
			<div class="l_c" @click="toinforma">重要资讯</div>
			<div class="r_c f-row-c">
				<img src="../static/img/rightarrow@2x.png" alt="" @click="toinforma"/>
			</div>
		</div>
		
		<div class="listcon">
			<div class="listbox" >
				<div class="signle f-row-start-b wrap" v-for="(item,index) in lista" :key="'signle-'+index" @click="todetail(item,'1')">
					<div class="bit"></div>
					<div class="title overfh" :title='item.title'>{{item.title||''}}</div>
					<div class="date">{{item.pubTime?item.pubTime.split(' ')[0]:''}}</div>
				</div>
			</div>			
			
			<!-- <div class="tip">最新通知</div>
			<div class="line"></div>
			
			<div class="signletwo overfh" v-for="(item,indey) in listb" :key="indey" @click="todetail(item,'2')">
				{{item.title}}
			</div> -->
			
		</div>
		
		
	</div>
	
</template>

<script>


export default {
 
  data: function() {
		return {
			lista:[],
			listb:[],
		  
		};
  },
  
  mounted() {
		this.getlista()
		// this.getlistb()
  },
  
  methods: {
	    getlista(){
	    	  this.$get(`web/info/list?pageSize=9&pageNo=1&infoType=2`).then(res=>{
	    		  if(res.success){
	    				this.lista = res.result.records
	    		  }
	    	  })
	    },
		
		getlistb(){
			  this.$get(`web/info/list?pageSize=2&pageNo=1&infoType=1`).then(res=>{
				  if(res.success){
						this.listb = res.result.records
				  }
			  })
		},
		
  		toinforma(){
  			this.$router.push({ path: '/teaminform?type=1' });
  		},

		todetail(item,index){
			if(index == "1"){
				this.$router.push({ path: '/textdetail?id='+item.id +'&type=4'});	
			}else if(index == "2"){
				this.$router.push({ path: '/textdetail?id='+item.id +'&type=5'});	
			}
		},
		
		
  },
  
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.newslistbox{
	width: 100%;
	.topbar{
		margin-bottom: 30px;
		.l_c{
			cursor: pointer;
			width: 326px;
			height: 50px;
			line-height: 50px;
			text-align: center;
			background: #E81414;
			border-radius: 25px;
			font-size: 20px;
			font-weight: 400;
			color: #FFFFFF;
		}
		.r_c{
			height: 50px;
			img{
				cursor: pointer;
				height: 20px;
				width: 107px;
			}
		}
		
	}
	
	
	.listcon{
		.listbox{
			padding-bottom: 10px;
		}
		.signle{
			box-sizing: border-box;
			margin-bottom: 17px;
			cursor: pointer;
			.bit{
				width: 5px;
				height: 5px;
				background: #E61F26;
				border-radius: 50%; 
				margin-top: 10px; 
			}
			.title{
				font-size: 18px;
				font-weight: 400;
				color: #000000;
				margin-left:10px;
				width: calc(100% - 135px);
			}
			.date{
				width: 120px;
				text-align: right;
				font-size: 18px;
				font-weight: 400;
				color: #666666;
			}
		}

		.signle:hover .title{
			color: #E61F26;
		}
		.signle:hover .date{
			color: #E61F26;
		}
		.signle:last-child{ 
			margin-bottom: 0px;
		}
		
	}
	
	
	
}

</style>
